import {
    SAVINGS_PLAN_CLEANING_BEGIN,
    SAVINGS_PLAN_CLEANING_SUCCESS,
    SAVINGS_PLAN_CLEANING_FAILURE
  } from '../constants'
  
  export function clearSavingsPlanSubscription() {
    return (dispatch) => {
      dispatch({
        type: SAVINGS_PLAN_CLEANING_BEGIN
      })
  
      try {
  
        dispatch({
          type: SAVINGS_PLAN_CLEANING_SUCCESS,
        })
  
      } catch (err) {
        dispatch({
          type: SAVINGS_PLAN_CLEANING_FAILURE,
          data: err?.message
        })
      }
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SAVINGS_PLAN_CLEANING_BEGIN:
      case SAVINGS_PLAN_CLEANING_FAILURE:
        return {
            ...state,
        }
      case SAVINGS_PLAN_CLEANING_SUCCESS:
        return {
            ...state,
            savingsPlan: null,
            client:null,
            entregaUsados: [],
            quotes:[]
        }
      default:
        return state
    }
  }